import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../store/slices/authSlice";
import "./login.scss";
import logoGif from "../../assets/images/logo.gif";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye, faEyeSlash,
  faFileMedical, faNotesMedical, faHospital,
  faStethoscope,
} from "@fortawesome/free-solid-svg-icons";

const Login = () => {
  const [email, setEmail]           = useState("");
  const [password, setPassword]     = useState("");
  const [formError, setFormError]   = useState("");
  const [isShow, setIsShow]         = useState(false);
  const dispatch                    = useDispatch();
  const navigate                    = useNavigate();
  const [isValidate, setIsValidate] = useState(true);
  const { isLoading }               = useSelector((state) => state.auth);

  const handleLogin = (e) => {
    e.preventDefault();
    if (email.length !== 0 && password.length !== 0) {
      dispatch(login({ email, password }))
        .unwrap()
        .then((res) => {
          if (res?.user && res?.token) navigate("/");
          else setFormError("Server not responding");
        })
        .catch((err) => setFormError(err?.errors?.[0]?.msg));
    } else setIsValidate(false);
  };

  const showPassword = () => {
    const pass = document.getElementById("pass-field");
    if (pass.type === "password") { setIsShow(true);  pass.type = "text"; }
    else                          { setIsShow(false); pass.type = "password"; }
  };

  return (
    <div className="login-wrapper">

      {/* ── Left branding panel ─────────────────────────────────── */}
      <div className="login-brand-panel d-none d-md-flex">

        {/* Ghost watermark stethoscope */}
        <div className="brand-watermark">
          <FontAwesomeIcon icon={faStethoscope} />
        </div>

        <div className="brand-inner">
          <h1 className="brand-title">Shafa Care</h1>
          <p className="brand-subtitle">Electronic Medical Records</p>
          <p className="brand-desc">
            Empowering healthcare professionals with a modern, secure, and
            efficient platform to deliver better patient outcomes.
          </p>
          <div className="brand-features">
            <div className="feature-item">
              <FontAwesomeIcon icon={faFileMedical} className="feature-icon" />
              Patient Management
            </div>
            <div className="feature-item">
              <FontAwesomeIcon icon={faNotesMedical} className="feature-icon" />
              Clinical Documentation
            </div>
            <div className="feature-item">
              <FontAwesomeIcon icon={faHospital} className="feature-icon" />
              Secure &amp; Compliant
            </div>
          </div>
        </div>
      </div>

      {/* ── Right form panel ────────────────────────────────────── */}
      <div className="login-form-panel">

        <div className="login-form-card">

          <div className="login-form-brand">
            <div className="login-form-brand-logo-wrap" aria-hidden="true">
              <img src={logoGif} alt="" className="login-form-brand-logo" width={36} height={36} />
            </div>
            <div className="login-form-brand-text">
              <h1 className="login-form-brand-name">Shafa EMR</h1>
              <p className="login-subtitle">Sign in to continue to your workspace</p>
            </div>
          </div>

          <form onSubmit={handleLogin} noValidate>
            <div className="field-group">
              <label className="field-label">Email Address</label>
              <input
                autoComplete="off"
                className={`login-input${email.length === 0 && !isValidate ? " is-invalid" : ""}`}
                type="email"
                onChange={(e) => { setEmail(e.target.value); setIsValidate(true); setFormError(""); }}
                placeholder="you@example.com"
              />
              {email.length === 0 && !isValidate && (
                <span className="field-error">Please enter your email.</span>
              )}
            </div>

            <div className="field-group">
              <label className="field-label">Password</label>
              <div className="password-field-wrap">
                <input
                  autoComplete="off"
                  type="password"
                  className={`login-input${password.length === 0 && !isValidate ? " is-invalid" : ""}`}
                  onChange={(e) => { setPassword(e.target.value); setIsValidate(true); setFormError(""); }}
                  id="pass-field"
                  placeholder="Enter your password"
                />
                <span className="toggle-password" onClick={showPassword}>
                  <FontAwesomeIcon icon={isShow ? faEyeSlash : faEye} />
                </span>
                {password.length === 0 && !isValidate && (
                  <span className="field-error">Please enter your password.</span>
                )}
              </div>
            </div>

            {formError?.length > 0 && (
              <div className="login-error-banner">{formError}</div>
            )}

            <button type="submit" className="login-submit-btn" disabled={isLoading}>
              {isLoading
                ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />Signing in...</>
                : "Sign In"}
            </button>
          </form>

          <div className="login-card-footer">
            <div className="footer-divider" />
            <small>Copyright &copy; 2024 <strong>Shafa EMR.</strong> All rights reserved.</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
